import { render, staticRenderFns } from "./NatureBreakDown.vue?vue&type=template&id=1c696b28&"
import script from "./NatureBreakDown.vue?vue&type=script&lang=js&"
export * from "./NatureBreakDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports